import React from 'react';
import CalendarConfig from '../../../../../consts/CalendarConfig';
import ColorPalette from '../../../../../colorpalette/ColorPalette';
import { Chip } from '@mui/material';

/**
 * Atalho de uma anamnese no histórico: pílula com a data, preenchida quando
 * é a anamnese em exibição.
 */
const DateHistory = ({ id, date, actived, onSelect }) => {
    const handleClick = () => {
        onSelect(id);
    };

    const formattedDate = CalendarConfig.GetDDMMAAAA(date);

    return (
        <Chip
            label={formattedDate}
            onClick={handleClick}
            variant={actived ? "filled" : "outlined"}
            sx={{
                backgroundColor: actived ? ColorPalette.blueMain : ColorPalette.white,
                color: actived ? ColorPalette.white : ColorPalette.textMedium,
                borderColor: actived ? ColorPalette.blueMain : ColorPalette.border,
                '&:hover': {
                    backgroundColor: actived ? ColorPalette.blueLight1 : ColorPalette.blueAlpha2,
                },
                fontWeight: actived ? 600 : 500,
                borderRadius: '999px',
                height: '28px',
                fontSize: '13px',
                '& .MuiChip-label': {
                    padding: '0 12px'
                }
            }}
        />
    );
};

export default DateHistory;
